import { UploadIcon } from "assests";
import { Button } from "components/UI/Button";

const UploadButton = ({ onClick, title, isDisabled, shortcut, className }) => {
  return (
    <Button
      type="button"
      variant={"action"}
      className={`flex items-center justify-between text-sm w-full font-semibold  gap-2 px-[11px] py-[6px] h-[38px] rounded-sm  hover:bg-global-white ${className}`}
      onClick={onClick}
      isDisabled={isDisabled}
    >
      <div className="flex items-center justify-start  gap-2">
        <UploadIcon
          fillColor={" var(--color-gray-700)"}
          strokeColor={" var(--color-gray-700)"}
          width={16}
          height={16}
        />
        <span>{title || "Upload"}</span>
      </div>
      <div className="text-xs font-medium text-global-paragraph-2 px-1 py-1 bg-transparent rounded border border-divider-stroke">
        {shortcut}
      </div>
    </Button>
  );
};

export default UploadButton;
